<template>
  <DropdownMenu v-if="visibilityLabel">
    <DropdownMenuTrigger as-child>
      <Badge :variant="isPublicSystem ? 'secondary' : 'outline'" class="cursor-pointer select-none">
        {{ visibilityLabel }}
      </Badge>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" class="w-36">
      <DropdownMenuItem :disabled="isPublicSystem || store.isLoading" @click="updateVisibility(true)">
        Public
      </DropdownMenuItem>
      <DropdownMenuItem :disabled="isPrivateSystem || store.isLoading" @click="updateVisibility(false)">
        Private
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup>
import { computed } from 'vue'
import { Badge } from '../../../../../../../resources/js/components/ui/badge/index.js'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../../../../../resources/js/components/ui/dropdown-menu/index.js'
import { useBusinessSystemStore } from '../../stores/businessSystems.js'

const props = defineProps({
  businessSystem: {
    type: Object,
    default: null,
  },
})

const store = useBusinessSystemStore()

const businessSystemId = computed(() => {
  const parsedId = Number(props.businessSystem?.id)

  if (!Number.isInteger(parsedId) || parsedId <= 0) {
    return null
  }

  return parsedId
})
const isPublicSystem = computed(() => props.businessSystem?.public === true)
const isPrivateSystem = computed(() => props.businessSystem?.public === false)
const visibilityLabel = computed(() => {
  if (isPublicSystem.value) {
    return 'Public'
  }

  if (isPrivateSystem.value) {
    return 'Private'
  }

  return null
})

const updateVisibility = async (isPublic) => {
  if (businessSystemId.value === null || props.businessSystem?.public === isPublic) {
    return
  }

  if (isPublic) {
    await store.setBusinessSystemAsPublic(businessSystemId.value)
    return
  }

  await store.setBusinessSystemAsPrivate(businessSystemId.value)
}
</script>
